import { Filter } from '../../../types/filter';
import { InstrumentValuesReportViewModel } from '@dynamik/common/clients/reporting-clients';

export const portfolioInstrumentFields: { label: string; name: Filter<InstrumentValuesReportViewModel, number> }[] = [
  { label: 'Quantity', name: 'quantityClosingBalance' },
  { label: 'Value', name: 'estimatedValueClosingBalance' },
  { label: 'Cost Price', name: 'costPriceClosingBalance' },
  { label: 'Unreal. UB', name: 'unrealizedProfitLossChangeInPeriod' },
  { label: 'Unreal. LY', name: 'unrealizedProfitLossEndOfLastYear' },
  { label: 'Unreal. YTD', name: 'unrealizedProfitLossChangeYearToDate' },
  { label: 'Real. YTD', name: 'realizedProfitLossChangeYearToDate' },
  { label: 'Divid. YTD', name: 'dividendChangeYearToDate' },
  { label: 'Int. YTD', name: 'interestChangeYearToDate' },
  { label: 'P&L YTD', name: 'profitLossChangeYearToDate' },
  { label: 'P&L Period', name: 'profitLossChangeInPeriod' }
];
